// Country and currency data mapping
// ISO 3166-1 alpha-2 country codes and ISO 4217 currency codes

export interface CountryData {
  code: string; // ISO 3166-1 alpha-2
  name: string;
  currency: string; // ISO 4217
  currencySymbol: string;
}

export const COUNTRIES: CountryData[] = [
  // A
  { code: "AF", name: "Afghanistan", currency: "AFN", currencySymbol: "؋" },
  { code: "AX", name: "Åland Islands", currency: "EUR", currencySymbol: "€" },
  { code: "AL", name: "Albania", currency: "ALL", currencySymbol: "L" },
  { code: "DZ", name: "Algeria", currency: "DZD", currencySymbol: "د.ج" },
  { code: "AS", name: "American Samoa", currency: "USD", currencySymbol: "$" },
  { code: "AD", name: "Andorra", currency: "EUR", currencySymbol: "€" },
  { code: "AO", name: "Angola", currency: "AOA", currencySymbol: "Kz" },
  { code: "AI", name: "Anguilla", currency: "XCD", currencySymbol: "$" },
  { code: "AQ", name: "Antarctica", currency: "USD", currencySymbol: "$" },
  { code: "AG", name: "Antigua and Barbuda", currency: "XCD", currencySymbol: "$" },
  { code: "AR", name: "Argentina", currency: "ARS", currencySymbol: "$" },
  { code: "AM", name: "Armenia", currency: "AMD", currencySymbol: "֏" },
  { code: "AW", name: "Aruba", currency: "AWG", currencySymbol: "ƒ" },
  { code: "AU", name: "Australia", currency: "AUD", currencySymbol: "A$" },
  { code: "AT", name: "Austria", currency: "EUR", currencySymbol: "€" },
  { code: "AZ", name: "Azerbaijan", currency: "AZN", currencySymbol: "₼" },
  // B
  { code: "BS", name: "Bahamas", currency: "BSD", currencySymbol: "$" },
  { code: "BH", name: "Bahrain", currency: "BHD", currencySymbol: ".د.ب" },
  { code: "BD", name: "Bangladesh", currency: "BDT", currencySymbol: "৳" },
  { code: "BB", name: "Barbados", currency: "BBD", currencySymbol: "$" },
  { code: "BY", name: "Belarus", currency: "BYN", currencySymbol: "Br" },
  { code: "BE", name: "Belgium", currency: "EUR", currencySymbol: "€" },
  { code: "BZ", name: "Belize", currency: "BZD", currencySymbol: "$" },
  { code: "BJ", name: "Benin", currency: "XOF", currencySymbol: "Fr" },
  { code: "BM", name: "Bermuda", currency: "BMD", currencySymbol: "$" },
  { code: "BT", name: "Bhutan", currency: "BTN", currencySymbol: "Nu." },
  { code: "BO", name: "Bolivia", currency: "BOB", currencySymbol: "Bs." },
  { code: "BQ", name: "Bonaire, Sint Eustatius and Saba", currency: "USD", currencySymbol: "$" },
  { code: "BA", name: "Bosnia and Herzegovina", currency: "BAM", currencySymbol: "КМ" },
  { code: "BW", name: "Botswana", currency: "BWP", currencySymbol: "P" },
  { code: "BV", name: "Bouvet Island", currency: "NOK", currencySymbol: "kr" },
  { code: "BR", name: "Brazil", currency: "BRL", currencySymbol: "R$" },
  { code: "IO", name: "British Indian Ocean Territory", currency: "USD", currencySymbol: "$" },
  { code: "BN", name: "Brunei Darussalam", currency: "BND", currencySymbol: "$" },
  { code: "BG", name: "Bulgaria", currency: "BGN", currencySymbol: "лв" },
  { code: "BF", name: "Burkina Faso", currency: "XOF", currencySymbol: "Fr" },
  { code: "BI", name: "Burundi", currency: "BIF", currencySymbol: "Fr" },
  // C
  { code: "CV", name: "Cabo Verde", currency: "CVE", currencySymbol: "$" },
  { code: "KH", name: "Cambodia", currency: "KHR", currencySymbol: "៛" },
  { code: "CM", name: "Cameroon", currency: "XAF", currencySymbol: "Fr" },
  { code: "CA", name: "Canada", currency: "CAD", currencySymbol: "C$" },
  { code: "KY", name: "Cayman Islands", currency: "KYD", currencySymbol: "$" },
  { code: "CF", name: "Central African Republic", currency: "XAF", currencySymbol: "Fr" },
  { code: "TD", name: "Chad", currency: "XAF", currencySymbol: "Fr" },
  { code: "CL", name: "Chile", currency: "CLP", currencySymbol: "$" },
  { code: "CN", name: "China", currency: "CNY", currencySymbol: "¥" },
  { code: "CX", name: "Christmas Island", currency: "AUD", currencySymbol: "A$" },
  { code: "CC", name: "Cocos (Keeling) Islands", currency: "AUD", currencySymbol: "A$" },
  { code: "CO", name: "Colombia", currency: "COP", currencySymbol: "$" },
  { code: "KM", name: "Comoros", currency: "KMF", currencySymbol: "Fr" },
  { code: "CG", name: "Congo", currency: "XAF", currencySymbol: "Fr" },
  { code: "CD", name: "Congo, Democratic Republic of the", currency: "CDF", currencySymbol: "Fr" },
  { code: "CK", name: "Cook Islands", currency: "NZD", currencySymbol: "NZ$" },
  { code: "CR", name: "Costa Rica", currency: "CRC", currencySymbol: "₡" },
  { code: "CI", name: "Côte d'Ivoire", currency: "XOF", currencySymbol: "Fr" },
  { code: "HR", name: "Croatia", currency: "EUR", currencySymbol: "€" },
  { code: "CU", name: "Cuba", currency: "CUP", currencySymbol: "$" },
  { code: "CW", name: "Curaçao", currency: "ANG", currencySymbol: "ƒ" },
  { code: "CY", name: "Cyprus", currency: "EUR", currencySymbol: "€" },
  { code: "CZ", name: "Czech Republic", currency: "CZK", currencySymbol: "Kč" },
  // D
  { code: "DK", name: "Denmark", currency: "DKK", currencySymbol: "kr" },
  { code: "DJ", name: "Djibouti", currency: "DJF", currencySymbol: "Fr" },
  { code: "DM", name: "Dominica", currency: "XCD", currencySymbol: "$" },
  { code: "DO", name: "Dominican Republic", currency: "DOP", currencySymbol: "$" },
  // E
  { code: "EC", name: "Ecuador", currency: "USD", currencySymbol: "$" },
  { code: "EG", name: "Egypt", currency: "EGP", currencySymbol: "£" },
  { code: "SV", name: "El Salvador", currency: "USD", currencySymbol: "$" },
  { code: "GQ", name: "Equatorial Guinea", currency: "XAF", currencySymbol: "Fr" },
  { code: "ER", name: "Eritrea", currency: "ERN", currencySymbol: "Nfk" },
  { code: "EE", name: "Estonia", currency: "EUR", currencySymbol: "€" },
  { code: "SZ", name: "Eswatini", currency: "SZL", currencySymbol: "L" },
  { code: "ET", name: "Ethiopia", currency: "ETB", currencySymbol: "Br" },
  // F
  { code: "FK", name: "Falkland Islands (Malvinas)", currency: "FKP", currencySymbol: "£" },
  { code: "FO", name: "Faroe Islands", currency: "DKK", currencySymbol: "kr" },
  { code: "FJ", name: "Fiji", currency: "FJD", currencySymbol: "$" },
  { code: "FI", name: "Finland", currency: "EUR", currencySymbol: "€" },
  { code: "FR", name: "France", currency: "EUR", currencySymbol: "€" },
  { code: "GF", name: "French Guiana", currency: "EUR", currencySymbol: "€" },
  { code: "PF", name: "French Polynesia", currency: "XPF", currencySymbol: "Fr" },
  { code: "TF", name: "French Southern Territories", currency: "EUR", currencySymbol: "€" },
  // G
  { code: "GA", name: "Gabon", currency: "XAF", currencySymbol: "Fr" },
  { code: "GM", name: "Gambia", currency: "GMD", currencySymbol: "D" },
  { code: "GE", name: "Georgia", currency: "GEL", currencySymbol: "₾" },
  { code: "DE", name: "Germany", currency: "EUR", currencySymbol: "€" },
  { code: "GH", name: "Ghana", currency: "GHS", currencySymbol: "₵" },
  { code: "GI", name: "Gibraltar", currency: "GIP", currencySymbol: "£" },
  { code: "GR", name: "Greece", currency: "EUR", currencySymbol: "€" },
  { code: "GL", name: "Greenland", currency: "DKK", currencySymbol: "kr" },
  { code: "GD", name: "Grenada", currency: "XCD", currencySymbol: "$" },
  { code: "GP", name: "Guadeloupe", currency: "EUR", currencySymbol: "€" },
  { code: "GU", name: "Guam", currency: "USD", currencySymbol: "$" },
  { code: "GT", name: "Guatemala", currency: "GTQ", currencySymbol: "Q" },
  { code: "GG", name: "Guernsey", currency: "GBP", currencySymbol: "£" },
  { code: "GN", name: "Guinea", currency: "GNF", currencySymbol: "Fr" },
  { code: "GW", name: "Guinea-Bissau", currency: "XOF", currencySymbol: "Fr" },
  { code: "GY", name: "Guyana", currency: "GYD", currencySymbol: "$" },
  // H
  { code: "HT", name: "Haiti", currency: "HTG", currencySymbol: "G" },
  { code: "HM", name: "Heard Island and McDonald Islands", currency: "AUD", currencySymbol: "A$" },
  { code: "VA", name: "Holy See", currency: "EUR", currencySymbol: "€" },
  { code: "HN", name: "Honduras", currency: "HNL", currencySymbol: "L" },
  { code: "HK", name: "Hong Kong", currency: "HKD", currencySymbol: "HK$" },
  { code: "HU", name: "Hungary", currency: "HUF", currencySymbol: "Ft" },
  // I
  { code: "IS", name: "Iceland", currency: "ISK", currencySymbol: "kr" },
  { code: "IN", name: "India", currency: "INR", currencySymbol: "₹" },
  { code: "ID", name: "Indonesia", currency: "IDR", currencySymbol: "Rp" },
  { code: "IR", name: "Iran, Islamic Republic of", currency: "IRR", currencySymbol: "﷼" },
  { code: "IQ", name: "Iraq", currency: "IQD", currencySymbol: "ع.د" },
  { code: "IE", name: "Ireland", currency: "EUR", currencySymbol: "€" },
  { code: "IM", name: "Isle of Man", currency: "GBP", currencySymbol: "£" },
  { code: "IT", name: "Italy", currency: "EUR", currencySymbol: "€" },
  // J
  { code: "JM", name: "Jamaica", currency: "JMD", currencySymbol: "$" },
  { code: "JP", name: "Japan", currency: "JPY", currencySymbol: "¥" },
  { code: "JE", name: "Jersey", currency: "GBP", currencySymbol: "£" },
  { code: "JO", name: "Jordan", currency: "JOD", currencySymbol: "د.ا" },
  // K
  { code: "KZ", name: "Kazakhstan", currency: "KZT", currencySymbol: "₸" },
  { code: "KE", name: "Kenya", currency: "KES", currencySymbol: "Sh" },
  { code: "KI", name: "Kiribati", currency: "AUD", currencySymbol: "A$" },
  { code: "KP", name: "Korea, Democratic People's Republic of", currency: "KPW", currencySymbol: "₩" },
  { code: "KR", name: "Korea, Republic of", currency: "KRW", currencySymbol: "₩" },
  { code: "KW", name: "Kuwait", currency: "KWD", currencySymbol: "د.ك" },
  { code: "KG", name: "Kyrgyzstan", currency: "KGS", currencySymbol: "с" },
  // L
  { code: "LA", name: "Lao People's Democratic Republic", currency: "LAK", currencySymbol: "₭" },
  { code: "LV", name: "Latvia", currency: "EUR", currencySymbol: "€" },
  { code: "LB", name: "Lebanon", currency: "LBP", currencySymbol: "£" },
  { code: "LS", name: "Lesotho", currency: "LSL", currencySymbol: "L" },
  { code: "LR", name: "Liberia", currency: "LRD", currencySymbol: "$" },
  { code: "LY", name: "Libya", currency: "LYD", currencySymbol: "ل.د" },
  { code: "LI", name: "Liechtenstein", currency: "CHF", currencySymbol: "CHF" },
  { code: "LT", name: "Lithuania", currency: "EUR", currencySymbol: "€" },
  { code: "LU", name: "Luxembourg", currency: "EUR", currencySymbol: "€" },
  // M
  { code: "MO", name: "Macao", currency: "MOP", currencySymbol: "P" },
  { code: "MG", name: "Madagascar", currency: "MGA", currencySymbol: "Ar" },
  { code: "MW", name: "Malawi", currency: "MWK", currencySymbol: "MK" },
  { code: "MY", name: "Malaysia", currency: "MYR", currencySymbol: "RM" },
  { code: "MV", name: "Maldives", currency: "MVR", currencySymbol: "Rf" },
  { code: "ML", name: "Mali", currency: "XOF", currencySymbol: "Fr" },
  { code: "MT", name: "Malta", currency: "EUR", currencySymbol: "€" },
  { code: "MH", name: "Marshall Islands", currency: "USD", currencySymbol: "$" },
  { code: "MQ", name: "Martinique", currency: "EUR", currencySymbol: "€" },
  { code: "MR", name: "Mauritania", currency: "MRU", currencySymbol: "UM" },
  { code: "MU", name: "Mauritius", currency: "MUR", currencySymbol: "₨" },
  { code: "YT", name: "Mayotte", currency: "EUR", currencySymbol: "€" },
  { code: "MX", name: "Mexico", currency: "MXN", currencySymbol: "$" },
  { code: "FM", name: "Micronesia, Federated States of", currency: "USD", currencySymbol: "$" },
  { code: "MD", name: "Moldova, Republic of", currency: "MDL", currencySymbol: "L" },
  { code: "MC", name: "Monaco", currency: "EUR", currencySymbol: "€" },
  { code: "MN", name: "Mongolia", currency: "MNT", currencySymbol: "₮" },
  { code: "ME", name: "Montenegro", currency: "EUR", currencySymbol: "€" },
  { code: "MS", name: "Montserrat", currency: "XCD", currencySymbol: "$" },
  { code: "MA", name: "Morocco", currency: "MAD", currencySymbol: "د.م." },
  { code: "MZ", name: "Mozambique", currency: "MZN", currencySymbol: "MT" },
  { code: "MM", name: "Myanmar", currency: "MMK", currencySymbol: "K" },
  // N
  { code: "NA", name: "Namibia", currency: "NAD", currencySymbol: "$" },
  { code: "NR", name: "Nauru", currency: "AUD", currencySymbol: "A$" },
  { code: "NP", name: "Nepal", currency: "NPR", currencySymbol: "₨" },
  { code: "NL", name: "Netherlands", currency: "EUR", currencySymbol: "€" },
  { code: "NC", name: "New Caledonia", currency: "XPF", currencySymbol: "Fr" },
  { code: "NZ", name: "New Zealand", currency: "NZD", currencySymbol: "NZ$" },
  { code: "NI", name: "Nicaragua", currency: "NIO", currencySymbol: "C$" },
  { code: "NE", name: "Niger", currency: "XOF", currencySymbol: "Fr" },
  { code: "NG", name: "Nigeria", currency: "NGN", currencySymbol: "₦" },
  { code: "NU", name: "Niue", currency: "NZD", currencySymbol: "NZ$" },
  { code: "NF", name: "Norfolk Island", currency: "AUD", currencySymbol: "A$" },
  { code: "MK", name: "North Macedonia", currency: "MKD", currencySymbol: "ден" },
  { code: "MP", name: "Northern Mariana Islands", currency: "USD", currencySymbol: "$" },
  { code: "NO", name: "Norway", currency: "NOK", currencySymbol: "kr" },
  // O
  { code: "OM", name: "Oman", currency: "OMR", currencySymbol: "﷼" },
  // P
  { code: "PK", name: "Pakistan", currency: "PKR", currencySymbol: "₨" },
  { code: "PW", name: "Palau", currency: "USD", currencySymbol: "$" },
  { code: "PS", name: "Palestine", currency: "ILS", currencySymbol: "₪" },
  { code: "PA", name: "Panama", currency: "PAB", currencySymbol: "B/." },
  { code: "PG", name: "Papua New Guinea", currency: "PGK", currencySymbol: "K" },
  { code: "PY", name: "Paraguay", currency: "PYG", currencySymbol: "₲" },
  { code: "PE", name: "Peru", currency: "PEN", currencySymbol: "S/." },
  { code: "PH", name: "Philippines", currency: "PHP", currencySymbol: "₱" },
  { code: "PN", name: "Pitcairn", currency: "NZD", currencySymbol: "NZ$" },
  { code: "PL", name: "Poland", currency: "PLN", currencySymbol: "zł" },
  { code: "PT", name: "Portugal", currency: "EUR", currencySymbol: "€" },
  { code: "PR", name: "Puerto Rico", currency: "USD", currencySymbol: "$" },
  // Q
  { code: "QA", name: "Qatar", currency: "QAR", currencySymbol: "﷼" },
  // R
  { code: "RE", name: "Réunion", currency: "EUR", currencySymbol: "€" },
  { code: "RO", name: "Romania", currency: "RON", currencySymbol: "lei" },
  { code: "RU", name: "Russian Federation", currency: "RUB", currencySymbol: "₽" },
  { code: "RW", name: "Rwanda", currency: "RWF", currencySymbol: "Fr" },
  // S
  { code: "BL", name: "Saint Barthélemy", currency: "EUR", currencySymbol: "€" },
  { code: "SH", name: "Saint Helena, Ascension and Tristan da Cunha", currency: "SHP", currencySymbol: "£" },
  { code: "KN", name: "Saint Kitts and Nevis", currency: "XCD", currencySymbol: "$" },
  { code: "LC", name: "Saint Lucia", currency: "XCD", currencySymbol: "$" },
  { code: "MF", name: "Saint Martin (French part)", currency: "EUR", currencySymbol: "€" },
  { code: "PM", name: "Saint Pierre and Miquelon", currency: "EUR", currencySymbol: "€" },
  { code: "VC", name: "Saint Vincent and the Grenadines", currency: "XCD", currencySymbol: "$" },
  { code: "WS", name: "Samoa", currency: "WST", currencySymbol: "T" },
  { code: "SM", name: "San Marino", currency: "EUR", currencySymbol: "€" },
  { code: "ST", name: "Sao Tome and Principe", currency: "STN", currencySymbol: "Db" },
  { code: "SA", name: "Saudi Arabia", currency: "SAR", currencySymbol: "﷼" },
  { code: "SN", name: "Senegal", currency: "XOF", currencySymbol: "Fr" },
  { code: "RS", name: "Serbia", currency: "RSD", currencySymbol: "дин" },
  { code: "SC", name: "Seychelles", currency: "SCR", currencySymbol: "₨" },
  { code: "SL", name: "Sierra Leone", currency: "SLL", currencySymbol: "Le" },
  { code: "SG", name: "Singapore", currency: "SGD", currencySymbol: "S$" },
  { code: "SX", name: "Sint Maarten (Dutch part)", currency: "ANG", currencySymbol: "ƒ" },
  { code: "SK", name: "Slovakia", currency: "EUR", currencySymbol: "€" },
  { code: "SI", name: "Slovenia", currency: "EUR", currencySymbol: "€" },
  { code: "SB", name: "Solomon Islands", currency: "SBD", currencySymbol: "$" },
  { code: "SO", name: "Somalia", currency: "SOS", currencySymbol: "Sh" },
  { code: "ZA", name: "South Africa", currency: "ZAR", currencySymbol: "R" },
  { code: "GS", name: "South Georgia and the South Sandwich Islands", currency: "GBP", currencySymbol: "£" },
  { code: "SS", name: "South Sudan", currency: "SSP", currencySymbol: "£" },
  { code: "ES", name: "Spain", currency: "EUR", currencySymbol: "€" },
  { code: "LK", name: "Sri Lanka", currency: "LKR", currencySymbol: "₨" },
  { code: "SD", name: "Sudan", currency: "SDG", currencySymbol: "£" },
  { code: "SR", name: "Suriname", currency: "SRD", currencySymbol: "$" },
  { code: "SJ", name: "Svalbard and Jan Mayen", currency: "NOK", currencySymbol: "kr" },
  { code: "SE", name: "Sweden", currency: "SEK", currencySymbol: "kr" },
  { code: "CH", name: "Switzerland", currency: "CHF", currencySymbol: "CHF" },
  { code: "SY", name: "Syrian Arab Republic", currency: "SYP", currencySymbol: "£" },
  // T
  { code: "TW", name: "Taiwan, Province of China", currency: "TWD", currencySymbol: "NT$" },
  { code: "TJ", name: "Tajikistan", currency: "TJS", currencySymbol: "ЅМ" },
  { code: "TZ", name: "Tanzania, United Republic of", currency: "TZS", currencySymbol: "Sh" },
  { code: "TH", name: "Thailand", currency: "THB", currencySymbol: "฿" },
  { code: "TL", name: "Timor-Leste", currency: "USD", currencySymbol: "$" },
  { code: "TG", name: "Togo", currency: "XOF", currencySymbol: "Fr" },
  { code: "TK", name: "Tokelau", currency: "NZD", currencySymbol: "NZ$" },
  { code: "TO", name: "Tonga", currency: "TOP", currencySymbol: "T$" },
  { code: "TT", name: "Trinidad and Tobago", currency: "TTD", currencySymbol: "$" },
  { code: "TN", name: "Tunisia", currency: "TND", currencySymbol: "د.ت" },
  { code: "TR", name: "Turkey", currency: "TRY", currencySymbol: "₺" },
  { code: "TM", name: "Turkmenistan", currency: "TMT", currencySymbol: "m" },
  { code: "TC", name: "Turks and Caicos Islands", currency: "USD", currencySymbol: "$" },
  { code: "TV", name: "Tuvalu", currency: "AUD", currencySymbol: "A$" },
  // U
  { code: "UG", name: "Uganda", currency: "UGX", currencySymbol: "Sh" },
  { code: "UA", name: "Ukraine", currency: "UAH", currencySymbol: "₴" },
  { code: "AE", name: "United Arab Emirates", currency: "AED", currencySymbol: "د.إ" },
  { code: "GB", name: "United Kingdom", currency: "GBP", currencySymbol: "£" },
  { code: "UM", name: "United States Minor Outlying Islands", currency: "USD", currencySymbol: "$" },
  { code: "US", name: "United States", currency: "USD", currencySymbol: "$" },
  { code: "UY", name: "Uruguay", currency: "UYU", currencySymbol: "$" },
  { code: "UZ", name: "Uzbekistan", currency: "UZS", currencySymbol: "лв" },
  // V
  { code: "VU", name: "Vanuatu", currency: "VUV", currencySymbol: "Vt" },
  { code: "VE", name: "Venezuela, Bolivarian Republic of", currency: "VES", currencySymbol: "Bs.S" },
  { code: "VN", name: "Vietnam", currency: "VND", currencySymbol: "₫" },
  { code: "VG", name: "Virgin Islands, British", currency: "USD", currencySymbol: "$" },
  { code: "VI", name: "Virgin Islands, U.S.", currency: "USD", currencySymbol: "$" },
  // W
  { code: "WF", name: "Wallis and Futuna", currency: "XPF", currencySymbol: "Fr" },
  // Y
  { code: "EH", name: "Western Sahara", currency: "MAD", currencySymbol: "د.م." },
  // Y
  { code: "YE", name: "Yemen", currency: "YER", currencySymbol: "﷼" },
  // Z
  { code: "ZM", name: "Zambia", currency: "ZMW", currencySymbol: "ZK" },
  { code: "ZW", name: "Zimbabwe", currency: "USD", currencySymbol: "$" },
];

// Unique currencies with their symbols
// Extracted from all countries to ensure all currencies are available
export const CURRENCIES: Array<{ code: string; symbol: string; name: string }> = [
  { code: "AFN", symbol: "؋", name: "Afghan Afghani" },
  { code: "ALL", symbol: "L", name: "Albanian Lek" },
  { code: "DZD", symbol: "د.ج", name: "Algerian Dinar" },
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "AOA", symbol: "Kz", name: "Angolan Kwanza" },
  { code: "XCD", symbol: "$", name: "East Caribbean Dollar" },
  { code: "ARS", symbol: "$", name: "Argentine Peso" },
  { code: "AMD", symbol: "֏", name: "Armenian Dram" },
  { code: "AWG", symbol: "ƒ", name: "Aruban Florin" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar" },
  { code: "AZN", symbol: "₼", name: "Azerbaijani Manat" },
  { code: "BSD", symbol: "$", name: "Bahamian Dollar" },
  { code: "BHD", symbol: ".د.ب", name: "Bahraini Dinar" },
  { code: "BDT", symbol: "৳", name: "Bangladeshi Taka" },
  { code: "BBD", symbol: "$", name: "Barbadian Dollar" },
  { code: "BYN", symbol: "Br", name: "Belarusian Ruble" },
  { code: "BZD", symbol: "$", name: "Belize Dollar" },
  { code: "XOF", symbol: "Fr", name: "West African CFA Franc" },
  { code: "BMD", symbol: "$", name: "Bermudian Dollar" },
  { code: "BTN", symbol: "Nu.", name: "Bhutanese Ngultrum" },
  { code: "BOB", symbol: "Bs.", name: "Bolivian Boliviano" },
  { code: "BAM", symbol: "KM", name: "Bosnia-Herzegovina Convertible Mark" },
  { code: "BWP", symbol: "P", name: "Botswanan Pula" },
  { code: "NOK", symbol: "kr", name: "Norwegian Krone" },
  { code: "BRL", symbol: "R$", name: "Brazilian Real" },
  { code: "BND", symbol: "$", name: "Brunei Dollar" },
  { code: "BGN", symbol: "лв", name: "Bulgarian Lev" },
  { code: "BIF", symbol: "Fr", name: "Burundian Franc" },
  { code: "CVE", symbol: "$", name: "Cape Verdean Escudo" },
  { code: "KHR", symbol: "៛", name: "Cambodian Riel" },
  { code: "XAF", symbol: "Fr", name: "Central African CFA Franc" },
  { code: "CAD", symbol: "C$", name: "Canadian Dollar" },
  { code: "KYD", symbol: "$", name: "Cayman Islands Dollar" },
  { code: "CLP", symbol: "$", name: "Chilean Peso" },
  { code: "CNY", symbol: "¥", name: "Chinese Yuan" },
  { code: "COP", symbol: "$", name: "Colombian Peso" },
  { code: "KMF", symbol: "Fr", name: "Comorian Franc" },
  { code: "CDF", symbol: "Fr", name: "Congolese Franc" },
  { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar" },
  { code: "CRC", symbol: "₡", name: "Costa Rican Colón" },
  { code: "CUP", symbol: "$", name: "Cuban Peso" },
  { code: "ANG", symbol: "ƒ", name: "Netherlands Antillean Guilder" },
  { code: "CZK", symbol: "Kč", name: "Czech Koruna" },
  { code: "DKK", symbol: "kr", name: "Danish Krone" },
  { code: "DJF", symbol: "Fr", name: "Djiboutian Franc" },
  { code: "DOP", symbol: "$", name: "Dominican Peso" },
  { code: "EGP", symbol: "£", name: "Egyptian Pound" },
  { code: "ERN", symbol: "Nfk", name: "Eritrean Nakfa" },
  { code: "SZL", symbol: "L", name: "Swazi Lilangeni" },
  { code: "ETB", symbol: "Br", name: "Ethiopian Birr" },
  { code: "FKP", symbol: "£", name: "Falkland Islands Pound" },
  { code: "FJD", symbol: "$", name: "Fijian Dollar" },
  { code: "GMD", symbol: "D", name: "Gambian Dalasi" },
  { code: "GEL", symbol: "₾", name: "Georgian Lari" },
  { code: "GHS", symbol: "₵", name: "Ghanaian Cedi" },
  { code: "GIP", symbol: "£", name: "Gibraltar Pound" },
  { code: "GTQ", symbol: "Q", name: "Guatemalan Quetzal" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "GNF", symbol: "Fr", name: "Guinean Franc" },
  { code: "GYD", symbol: "$", name: "Guyanaese Dollar" },
  { code: "HTG", symbol: "G", name: "Haitian Gourde" },
  { code: "HNL", symbol: "L", name: "Honduran Lempira" },
  { code: "HKD", symbol: "HK$", name: "Hong Kong Dollar" },
  { code: "HUF", symbol: "Ft", name: "Hungarian Forint" },
  { code: "ISK", symbol: "kr", name: "Icelandic Króna" },
  { code: "INR", symbol: "₹", name: "Indian Rupee" },
  { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah" },
  { code: "IRR", symbol: "﷼", name: "Iranian Rial" },
  { code: "IQD", symbol: "ع.د", name: "Iraqi Dinar" },
  { code: "ILS", symbol: "₪", name: "Palestinian Sheqel" },
  { code: "JMD", symbol: "$", name: "Jamaican Dollar" },
  { code: "JPY", symbol: "¥", name: "Japanese Yen" },
  { code: "JOD", symbol: "د.ا", name: "Jordanian Dinar" },
  { code: "KZT", symbol: "₸", name: "Kazakhstani Tenge" },
  { code: "KES", symbol: "Sh", name: "Kenyan Shilling" },
  { code: "KPW", symbol: "₩", name: "North Korean Won" },
  { code: "KRW", symbol: "₩", name: "South Korean Won" },
  { code: "KWD", symbol: "د.ك", name: "Kuwaiti Dinar" },
  { code: "KGS", symbol: "с", name: "Kyrgystani Som" },
  { code: "LAK", symbol: "₭", name: "Laotian Kip" },
  { code: "LBP", symbol: "£", name: "Lebanese Pound" },
  { code: "LSL", symbol: "L", name: "Lesotho Loti" },
  { code: "LRD", symbol: "$", name: "Liberian Dollar" },
  { code: "LYD", symbol: "ل.د", name: "Libyan Dinar" },
  { code: "CHF", symbol: "CHF", name: "Swiss Franc" },
  { code: "MOP", symbol: "P", name: "Macanese Pataca" },
  { code: "MGA", symbol: "Ar", name: "Malagasy Ariary" },
  { code: "MWK", symbol: "MK", name: "Malawian Kwacha" },
  { code: "MYR", symbol: "RM", name: "Malaysian Ringgit" },
  { code: "MVR", symbol: "Rf", name: "Maldivian Rufiyaa" },
  { code: "MUR", symbol: "₨", name: "Mauritian Rupee" },
  { code: "MXN", symbol: "$", name: "Mexican Peso" },
  { code: "MDL", symbol: "L", name: "Moldovan Leu" },
  { code: "MNT", symbol: "₮", name: "Mongolian Tugrik" },
  { code: "MAD", symbol: "د.م.", name: "Moroccan Dirham" },
  { code: "MZN", symbol: "MT", name: "Mozambican Metical" },
  { code: "MMK", symbol: "K", name: "Myanma Kyat" },
  { code: "NAD", symbol: "$", name: "Namibian Dollar" },
  { code: "NPR", symbol: "₨", name: "Nepalese Rupee" },
  { code: "XPF", symbol: "Fr", name: "CFP Franc" },
  { code: "NIO", symbol: "C$", name: "Nicaraguan Córdoba" },
  { code: "NGN", symbol: "₦", name: "Nigerian Naira" },
  { code: "MKD", symbol: "ден", name: "Macedonian Denar" },
  { code: "OMR", symbol: "﷼", name: "Omani Rial" },
  { code: "PKR", symbol: "₨", name: "Pakistani Rupee" },
  { code: "PAB", symbol: "B/.", name: "Panamanian Balboa" },
  { code: "PGK", symbol: "K", name: "Papua New Guinean Kina" },
  { code: "PYG", symbol: "₲", name: "Paraguayan Guarani" },
  { code: "PEN", symbol: "S/.", name: "Peruvian Nuevo Sol" },
  { code: "PHP", symbol: "₱", name: "Philippine Peso" },
  { code: "PLN", symbol: "zł", name: "Polish Zloty" },
  { code: "QAR", symbol: "﷼", name: "Qatari Rial" },
  { code: "RON", symbol: "lei", name: "Romanian Leu" },
  { code: "RUB", symbol: "₽", name: "Russian Ruble" },
  { code: "RWF", symbol: "Fr", name: "Rwandan Franc" },
  { code: "SHP", symbol: "£", name: "Saint Helena Pound" },
  { code: "WST", symbol: "T", name: "Samoan Tala" },
  { code: "STN", symbol: "Db", name: "São Tomé and Príncipe Dobra" },
  { code: "SAR", symbol: "﷼", name: "Saudi Riyal" },
  { code: "RSD", symbol: "дин", name: "Serbian Dinar" },
  { code: "SCR", symbol: "₨", name: "Seychellois Rupee" },
  { code: "SLL", symbol: "Le", name: "Sierra Leonean Leone" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  { code: "SBD", symbol: "$", name: "Solomon Islands Dollar" },
  { code: "SOS", symbol: "Sh", name: "Somali Shilling" },
  { code: "ZAR", symbol: "R", name: "South African Rand" },
  { code: "SSP", symbol: "£", name: "South Sudanese Pound" },
  { code: "LKR", symbol: "₨", name: "Sri Lankan Rupee" },
  { code: "SDG", symbol: "£", name: "Sudanese Pound" },
  { code: "SRD", symbol: "$", name: "Surinamese Dollar" },
  { code: "SEK", symbol: "kr", name: "Swedish Krona" },
  { code: "SYP", symbol: "£", name: "Syrian Pound" },
  { code: "TWD", symbol: "NT$", name: "Taiwan Dollar" },
  { code: "TJS", symbol: "ЅМ", name: "Tajikistani Somoni" },
  { code: "TZS", symbol: "Sh", name: "Tanzanian Shilling" },
  { code: "THB", symbol: "฿", name: "Thai Baht" },
  { code: "TOP", symbol: "T$", name: "Tongan Pa'anga" },
  { code: "TTD", symbol: "$", name: "Trinidad and Tobago Dollar" },
  { code: "TND", symbol: "د.ت", name: "Tunisian Dinar" },
  { code: "TRY", symbol: "₺", name: "Turkish Lira" },
  { code: "TMT", symbol: "m", name: "Turkmenistani Manat" },
  { code: "UGX", symbol: "Sh", name: "Ugandan Shilling" },
  { code: "UAH", symbol: "₴", name: "Ukrainian Hryvnia" },
  { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
  { code: "UYU", symbol: "$", name: "Uruguayan Peso" },
  { code: "UZS", symbol: "лв", name: "Uzbekistan Som" },
  { code: "VUV", symbol: "Vt", name: "Vanuatu Vatu" },
  { code: "VES", symbol: "Bs.S", name: "Venezuelan Bolívar" },
  { code: "VND", symbol: "₫", name: "Vietnamese Dong" },
  { code: "YER", symbol: "﷼", name: "Yemeni Rial" },
  { code: "ZMW", symbol: "ZK", name: "Zambian Kwacha" },
  { code: "MRU", symbol: "UM", name: "Mauritanian Ouguiya" },
];

export function getCountryByCode(code: string): CountryData | undefined {
  return COUNTRIES.find((c) => c.code.toUpperCase() === code.toUpperCase());
}

export function getCurrencyByCode(code: string): { code: string; symbol: string; name: string } | undefined {
  return CURRENCIES.find((c) => c.code.toUpperCase() === code.toUpperCase());
}

export function getCurrencySymbol(currencyCode: string): string {
  const currency = getCurrencyByCode(currencyCode);
  return currency?.symbol || currencyCode;
}


